import React from "react";
import { ReplaceSpecialCharToText, ReplaceTextToSpecialChar } from "../../../Helper/WidgetDataCommon";
import SearchableSelect from "../Controls/SearchableSelect";

const ConnectionControl = (props) => {

  const options = props.dtList.map((item, index) => {
    return { value: ReplaceSpecialCharToText(item.value), label: ReplaceTextToSpecialChar(item.text) }
  });

  let finalOptions = [{ value: "Please Select", label: "Please Select" }, ...options,];

  if (props.isGSheet) {
    finalOptions = [...finalOptions, {
      value: "Divider",
      label: "-----------------------------------------", isDisabled: true
    },
    { value: "CreateNewConnection", label: "Create New Connection" },
    { value: "EditExistingConnection", label: "Edit / Delete Connection" }];
  }

  return (
    <React.Fragment>
      <p>Connection</p>
      <SearchableSelect
        onChangeHandler={props.onChangeHandler}
        optionList={finalOptions}
        value={props.value === '' ? 'Please Select' : props.value} />

      {/* <select
        value-key="connection"
        value={props.value}
        onChange={props.onChangeHandler}
      >
        <option value="">Please Select</option>
        {props.dtList.map((item, index) => {
          return (
            <option key={index} value={ReplaceSpecialCharToText(item.value)}>
              <HtmlParser htmlString={ReplaceTextToSpecialChar(item.text).replace(/ /g, "&nbsp;")} />
            </option>
          );
        })}

        {props.isGSheet &&
          <>
            <option disabled="disabled" value="Divider">-----------------------------------------</option>
            <option value="CreateNewConnection">Create New Connection</option>
            <option value="EditExistingConnection">Edit / Delete Connection</option>
          </>
        }
      </select> */}
      <span
        style={{
          display: props.isValid ? "none" : "block",
          color: "red",
          paddingLeft: "5px",
        }}
      >
        Required
      </span>
    </React.Fragment>
  );
};

export default ConnectionControl;